import { createRequestActionTypes } from "../../shared/utility";

export const CountryActions = {
    fetchCountryList: createRequestActionTypes('FETCH_COUNTRY_LIST'),
    createUpdateCountry: createRequestActionTypes('CREATE_UPDATE_COUNTRY'),
    fetchMasterCountryList: createRequestActionTypes('FETCH_MASTER_COUNTRY_LIST'),
}